import Chapter from '@/models/Chapter';
import Subchapter from '@/models/Subchapter';
import { useEffect, useRef, useState } from 'react';

type UseChapterOptions = {
  chapters: Chapter[];
};

export const useChapter = (options: UseChapterOptions) => {
  const { chapters } = options;

  const lastChapterRef = useRef<number>();
  const [chapter, setChapter] = useState(chapters.at(0));

  useEffect(() => {
    const lastChapter = chapters.find(
      chapter => chapter.id === lastChapterRef.current,
    );
    setChapter(lastChapter || chapters.at(0));
  }, [chapters]);

  const setChapterMiddleware = (chapter: Chapter) => {
    lastChapterRef.current = chapter.id;
    setChapter(chapter);
  };

  return { chapter, setChapter: setChapterMiddleware };
};

type UseSubchapterOptions = {
  chapter?: Chapter;
};

export const useSubchapter = (options: UseSubchapterOptions) => {
  const { chapter } = options;

  const lastSubchapterRef = useRef<number>();

  const [subchapter, setSubchapter] = useState(chapter?.items?.at(0));

  useEffect(() => {
    const lastSubchapter = chapter?.items?.find(
      chapter => chapter.id === lastSubchapterRef.current,
    );

    setSubchapter(lastSubchapter || chapter?.items?.at(0));
  }, [chapter]);

  const setSubchapterMiddleware = (subchapter: Subchapter) => {
    lastSubchapterRef.current = subchapter.id;
    setSubchapter(subchapter);
  };

  return { subchapter, setSubchapter: setSubchapterMiddleware };
};
